import { ApplicationConfig } from '@angular/core';

import { CUSTOM_PROVIDERS_CONFIG, ROUTING_CONFIG, SERVICES_PROVIDES } from './app.providers';

export const appConfig: ApplicationConfig = {
  providers: [...SERVICES_PROVIDES, ...ROUTING_CONFIG, ...CUSTOM_PROVIDERS_CONFIG],
};
